module.exports = __webpack_public_path__ + "static/media/whitelogo.ed365571.svg";